import React from 'react';

interface LinesSplinesIconProps {
  style?: React.CSSProperties;
}

const LinesSplinesIcon: React.FC<LinesSplinesIconProps> = ({ style }) => {
  return (
    <svg style={style} viewBox="0 0 26 30">
      <title>Line Annotation</title>
      <g clipPath="url(#clip0)">
        <path d="M6.495 3.75L0 7.5v15l6.495 3.75.6-11.25-.6-11.25z" fill="#6A11EA" />
        <path d="M6.495 26.25L12.99 30l.6-15-.6-15-6.495 3.75v22.5z" fill="#943CFF" />
        <path d="M19.485 3.75L12.99 0v30l6.495-3.75.6-11.25-.6-11.25z" fill="#DD45D3" />
        <path d="M19.485 26.25l6.495-3.75v-15l-6.495-3.75v22.5z" fill="#FD9D52" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h25.98v30H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinesSplinesIcon;
